export const PHONE_REGEXP = /^\+?\d*$/;
